import React from 'react'
import { Button } from '@leverege/ui-elements'
import { GlobalState } from '@leverege/ui-redux'
import { push } from 'connected-react-router'

function PlyLayerShopFloorLink( props ) {
  const { value } = props

  const handleNavigate = () => {
    const path = `moldHalves/${value}/plyLayerShopFloor`

    const layoutName = 'Ply Layer'
    const queryPrefix = 's'
    const encodedLayoutName = layoutName.replace( /\s/g, '' )
  
    const searchParams = new URLSearchParams()
    searchParams.append( 'v', `${queryPrefix}:${encodedLayoutName}` )
  
    const pathWithQuery = `${path}?${searchParams.toString()}`

    GlobalState.dispatch( push( pathWithQuery ) )
  }

  return (
    <Button variant="link" onClick={handleNavigate}>
      Ply Inspection
    </Button>
  )
}

export default {
  objectType : 'moldHalf',
  attrName : 'moldHalf.PlyLayerShopFloor',
  renderer : ( props ) => {
    let moldHalfId = props.value

    if ( !moldHalfId ) {
      moldHalfId = props[0]
    }

    return React.createElement( PlyLayerShopFloorLink, {
      value : moldHalfId
    } )
  }
}
